import { type Route } from '@angular/router';
import {
	OperatorLoginComponent,
	operatorLoginGuard,
	operatorSessionGuard,
} from '@pressteaze/auth';
import { OperatorHomeComponent } from './components/home/operator-home.component';
import { OperatorDashboardComponent } from './components/dashboard/operator-dashboard.component';
import { OperatorShellComponent } from './components/operator-shell.component';

export const appRoutes: Route[] = [
	{
		path: 'login',
		component: OperatorLoginComponent,
		canActivate: [operatorLoginGuard],
	},
	{
		path: '',
		component: OperatorShellComponent,
		canActivate: [operatorSessionGuard],
		children: [
			{ path: '', pathMatch: 'full', component: OperatorDashboardComponent },
			{ path: 'shift', component: OperatorHomeComponent },
		],
	},
	{ path: '**', redirectTo: '' },
];
